<template>
	<el-dialog v-model="dialogVisible" title="选择产品" width="1200px" :close-on-click-modal="false"
		:destroy-on-close="true" align-center>

		<!-- 搜索过滤 -->
		<el-card class="filter-card">
			<el-form :inline="true" :model="filterForm" class="filter-form">
				<el-form-item label="产品名称">
					<el-input v-model="filterForm.name" placeholder="请输入产品名称" clearable @keyup.enter="handleSearch" />
				</el-form-item>
				<!-- <el-form-item label="产品类型">
          <el-select v-model="filterForm.type" placeholder="请选择产品类型" clearable>
            <el-option label="硬件" value="hardware" />
            <el-option label="软件" value="software" />
            <el-option label="服务" value="service" />
          </el-select>
        </el-form-item> -->
				<el-form-item>
					<el-button type="primary" @click="handleSearch">
						<el-icon>
							<Search />
						</el-icon> 搜索
					</el-button>
					<el-button @click="resetForm">
						<el-icon>
							<Refresh />
						</el-icon> 重置
					</el-button>
					<el-button type="success" @click="handleAdd">
						<el-icon>
							<Plus />
						</el-icon> 新增产品
					</el-button>
				</el-form-item>
			</el-form>
		</el-card>

		<!-- 产品列表 -->
		<el-card class="table-card">
			<el-table :data="productList" style="width: 100%" v-loading="loading"
				@selection-change="handleSelectionChange">
				<el-table-column type="selection" width="55" />
				<el-table-column type="index" label="序号" width="60" />
				<el-table-column prop="name" label="产品名称" min-width="120" />
				<el-table-column prop="specification" label="规格型号" width="120" />
				<!-- <el-table-column prop="type" label="产品类型" width="100">
          <template #default="scope">
            <el-tag :type="getProductTypeTag(scope.row.type)">
              {{ getProductTypeText(scope.row.type) }}
            </el-tag>
          </template>
        </el-table-column> -->
				<el-table-column prop="unit" label="单位" width="80" />
				<el-table-column prop="unitPrice" label="单价" width="120">
					<template #default="scope">
						{{ formatAmount(scope.row.unitPrice) }}
					</template>
				</el-table-column>
				<el-table-column prop="costPrice" label="成本价" width="120">
					<template #default="scope">
						{{ formatAmount(scope.row.costPrice) }}
					</template>
				</el-table-column>
				<el-table-column prop="status" label="状态" width="100">
					<template #default="scope">
						<el-tag :type="scope.row.status === 0 ? 'success' : 'danger'">
							{{ scope.row.status === 0 ? '上架' : '停售' }}
						</el-tag>
					</template>
				</el-table-column>
				<el-table-column label="操作" width="150" fixed="right">
					<template #default="scope">
						<el-button type="primary" link @click="handleEdit(scope.row)">编辑</el-button>
						<!-- <el-button type="danger" link @click="handleDelete(scope.row)">删除</el-button> -->
					</template>
				</el-table-column>
			</el-table>

			<div class="pagination-container">
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
					:current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
					layout="total, sizes, prev, pager, next, jumper" :total="total">
				</el-pagination>
			</div>
		</el-card>

		<template #footer>
			<span class="dialog-footer">
				<el-button @click="handleCancel">取 消</el-button>
				<el-button type="primary" @click="handleConfirm" :disabled="!selectedProducts.length">
					确 定
				</el-button>
			</span>
		</template>
	</el-dialog>

	<!-- 新增/编辑产品对话框 -->
	<el-dialog v-model="productDialogVisible" :title="productDialogTitle" width="600px" :close-on-click-modal="false"
		append-to-body>
		<el-form ref="productFormRef" :model="productForm" :rules="productRules" label-width="100px">
			<el-form-item label="产品名称" prop="name">
				<el-input v-model="productForm.name" placeholder="请输入产品名称" />
			</el-form-item>
			<el-form-item label="规格型号" prop="specification">
				<el-input v-model="productForm.specification" placeholder="请输入规格型号" />
			</el-form-item>
			<el-form-item label="单位" prop="unit">
				<el-input v-model="productForm.unit" placeholder="请输入单位" />
			</el-form-item>
			<el-form-item label="单价" prop="unitPrice">
				<el-input-number v-model="productForm.unitPrice" :min="0" :precision="2" :step="0.01" />
			</el-form-item>
			<el-form-item label="成本价" prop="costPrice">
				<el-input-number v-model="productForm.costPrice" :min="0" :precision="2" :step="0.01" />
			</el-form-item>
			<el-form-item label="状态" prop="status">
				<el-radio-group v-model="productForm.status">
					<el-radio :label="0">上架</el-radio>
					<el-radio :label="1">停售</el-radio>
				</el-radio-group>
			</el-form-item>
		</el-form>
		<template #footer>
			<span class="dialog-footer">
				<el-button @click="productDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="submitProductForm">确 定</el-button>
			</span>
		</template>
	</el-dialog>
</template>

<script>
	import {
		ref,
		reactive,
		onMounted,
		watch
	} from 'vue'
	import {
		ElMessage,
		ElMessageBox
	} from 'element-plus'
	import {
		Search,
		Refresh,
		Plus
	} from '@element-plus/icons-vue'
	import {
		getProductList,
		addProduct,
		deleteProduct
	} from '@/api/product'

	export default {
		name: 'ProductSelector',
		components: {
			Search,
			Refresh,
			Plus
		},
		props: {
			modelValue: {
				type: Boolean,
				default: false
			}
		},
		emits: ['update:modelValue', 'select'],
		setup(props, {
			emit
		}) {
			const dialogVisible = ref(false)
			const loading = ref(false)
			const filterForm = reactive({
				name: '',
				type: ''
			})
			const productList = ref([])
			const currentPage = ref(1)
			const pageSize = ref(10)
			const total = ref(0)
			const selectedProducts = ref([])
			const productDialogVisible = ref(false)
			const productDialogTitle = ref('')
			const productFormRef = ref(null)
			const productForm = reactive({
				id: '',
				name: '',
				specification: '',
				unit: '',
				unitPrice: 0,
				costPrice: 0,
				status: 0
			})
			const productRules = {
				name: [{
					required: true,
					message: '请输入产品名称',
					trigger: 'blur'
				}],
				specification: [{
					required: true,
					message: '请输入规格型号',
					trigger: 'blur'
				}],
				unit: [{
					required: true,
					message: '请输入单位',
					trigger: 'blur'
				}],
				unitPrice: [{
					required: true,
					message: '请输入单价',
					trigger: 'blur'
				}],
				costPrice: [{
					required: true,
					message: '请输入成本价',
					trigger: 'blur'
				}],
				status: [{
					required: true,
					message: '请选择状态',
					trigger: 'change'
				}]
			}

			// 监听 modelValue 变化
			watch(() => props.modelValue, (val) => {
				dialogVisible.value = val
			})

			// 监听对话框可见性变化
			watch(dialogVisible, (val) => {
				emit('update:modelValue', val)
			})

			const fetchData = async () => {
				loading.value = true
				try {
					const params = {
						current: currentPage.value,
						size: pageSize.value,
						...filterForm
					}
					const res = await getProductList(params)
					productList.value = res.data.records
					total.value = res.data.total
				} catch (error) {
					console.error('获取产品列表失败:', error)
					ElMessage.error('获取产品列表失败')
				} finally {
					loading.value = false
				}
			}

			const handleSearch = () => {
				currentPage.value = 1
				fetchData()
			}

			const resetForm = () => {
				filterForm.name = ''
				filterForm.type = ''
				handleSearch()
			}

			const handleSizeChange = (val) => {
				pageSize.value = val
				fetchData()
			}

			const handleCurrentChange = (val) => {
				currentPage.value = val
				fetchData()
			}

			const handleSelectionChange = (selection) => {
				selectedProducts.value = selection
			}

			const handleCancel = () => {
				dialogVisible.value = false
				selectedProducts.value = []
			}

			const handleConfirm = () => {
				emit('select', selectedProducts.value)
				dialogVisible.value = false
				selectedProducts.value = []
			}

			const getProductTypeTag = (type) => {
				const typeMap = {
					hardware: 'primary',
					software: 'success',
					service: 'warning'
				}
				return typeMap[type] || 'info'
			}

			const getProductTypeText = (type) => {
				const typeMap = {
					hardware: '硬件',
					software: '软件',
					service: '服务'
				}
				return typeMap[type] || type
			}

			const formatAmount = (amount) => {
				return amount ? `¥${amount.toFixed(2)}` : '¥0.00'
			}

			const handleAdd = () => {
				productDialogTitle.value = '新增产品'
				Object.assign(productForm, {
					id: '',
					name: '',
					specification: '',
					unit: '',
					unitPrice: 0,
					costPrice: 0,
					status: 0
				})
				productDialogVisible.value = true
			}

			const handleEdit = (row) => {
				productDialogTitle.value = '编辑产品'
				Object.assign(productForm, row)
				productDialogVisible.value = true
			}

			const handleDelete = async (row) => {
				try {
					await ElMessageBox.confirm('确认删除该产品吗？', '提示', {
						type: 'warning'
					})
					await deleteProduct(row.id)
					ElMessage.success('删除成功')
					fetchData()
				} catch (error) {
					if (error !== 'cancel') {
						console.error('删除产品失败:', error)
						ElMessage.error('删除失败')
					}
				}
			}

			const submitProductForm = async () => {
				if (!productFormRef.value) return
				try {
					await productFormRef.value.validate()
					if (productForm.id) {
						await addProduct(productForm)
						ElMessage.success('更新成功')
					} else {
						await addProduct(productForm)
						ElMessage.success('添加成功')
					}
					productDialogVisible.value = false
					fetchData()
				} catch (error) {
					console.error('提交表单失败:', error)
					ElMessage.error('提交失败')
				}
			}

			onMounted(() => {
				fetchData()
			})

			return {
				dialogVisible,
				loading,
				filterForm,
				productList,
				currentPage,
				pageSize,
				total,
				selectedProducts,
				handleSearch,
				resetForm,
				handleSizeChange,
				handleCurrentChange,
				handleSelectionChange,
				handleCancel,
				handleConfirm,
				getProductTypeTag,
				getProductTypeText,
				formatAmount,
				productDialogVisible,
				productDialogTitle,
				productFormRef,
				productForm,
				productRules,
				handleAdd,
				handleEdit,
				handleDelete,
				submitProductForm
			}
		}
	}
</script>

<style scoped>
	.filter-card {
		margin-bottom: 20px;
	}

	.filter-form {
		display: flex;
		flex-wrap: wrap;
		gap: 10px;
	}

	.table-card {
		margin-bottom: 20px;
	}

	.pagination-container {
		margin-top: 20px;
		text-align: right;
	}

	:deep(.el-table .cell) {
		white-space: nowrap;
	}
</style>